import LogRocket from 'logrocket'

if (process.env.NODE_ENV === 'production') LogRocket.init(process.env.NODE_ENV === 'development'
  ? '1lg3k6/proft-dashboard-dev'
  : '1lg3k6/proft-dashboard-prod'
)

export default LogRocket
